import { render, staticRenderFns } from "./Questionlist.vue?vue&type=template&id=63355af3&scoped=true"
import script from "./Questionlist.vue?vue&type=script&lang=js"
export * from "./Questionlist.vue?vue&type=script&lang=js"
import style0 from "./Questionlist.vue?vue&type=style&index=0&id=63355af3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63355af3",
  null
  
)

export default component.exports